<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Vorlage bearbeiten: {{ templateName }}</h4>
  <button type="button" class="close" aria-label="Schließen" aria-describedby="modal-title" (click)="modal.dismiss('')">
    <span class="fas fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="templateForm" novalidate>
    <div class="alert alert-warning" role="alert">
      <strong><i class="fas fa-exclamation-triangle"></i> Wichtig:</strong> Das Speichern oder Ändern dieser Vorlage
      löst einen erneuten Verifizierungsprozess auf der Facebook-Website aus, der bis zu 24 Stunden dauern kann.
    </div>
    <div class="form-group">
      <label for="content">Vorlageninhalt</label>
      <textarea
        class="form-control border-main p-3 w-100"
        placeholder="Vorlageninhalt eingeben..."
        rows="10"
        formControlName="content"
        [class.is-invalid]="templateForm.get('content')?.invalid && templateForm.get('content')?.touched"
      ></textarea>
      <div
        class="invalid-feedback"
        *ngIf="templateForm.get('content')?.invalid && templateForm.get('content')?.touched"
      >
        Inhalt ist erforderlich
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onCancel()">Abbrechen</button>
  <button type="button" ngbAutofocus class="btn btn-primary" (click)="onSave()" [disabled]="templateForm.invalid">
    Speichern
  </button>
</div>
